/**
 * Loss History Detail (#33939) — shared constants.
 *
 * This module is the ONE place that owns the boundary where a loss-history entry is written.
 * Every writer (the staff-fe manual add form, the IMT `_claims.json` importer, the A+/Verisk
 * property pull) and every reader (the farm rater, the staff Loss Summary rollup, the policy-mod
 * and offer authz gates) shares these definitions so the source labels, the human policy-type
 * labels, and the summary lookback windows can never drift between layers. See ./build for the
 * entry factory, ./normalize for the single date-normalization rule, and ./authz for the gates.
 */

/** Source label for a manually-added entry (vs. an auto-pulled report entry). */
export const MANUAL_ENTRY_SOURCE = 'Manual Entry';

/** Source label for an A+/Verisk-property loss-report-pulled claim. */
export const APLUS_LOSS_SOURCE = 'A+ Property';

/** Source label for an IMT/prior-carrier imported claim (`_claims.json`). */
export const IMT_CLAIM_SOURCE = 'IMT Claims';

/**
 * Human "Policy Type" label for the migrated Branch farm type (owner decision, #33939):
 * F→Farm, Z→Home, Y→Rental (NOT "Farm Home"/"Farm Rental").
 */
export const LOSS_POLICY_TYPE_LABELS: Record<string, string> = { F: 'Farm', Z: 'Home', Y: 'Rental' };

/** Lookback windows (years) surfaced in the Loss Summary frequency rollup. */
export const LOSS_SUMMARY_WINDOWS = [3, 5] as const;
